import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosSharedAnticiposAnticipoInformacionComponent {
  data
  solicitudId
  onSelect

  $onInit () {
    this.leyenda = this.data.cancelado ? 'Solicitud cancelada' :
      this.data.pagado ? 'Pago aplicado' :
        this.data.autorizado ? 'Autorizado, pendiente de pago' : 'En proceso de autorización'
  }
}

module.component('viaticosSharedAnticiposAnticipoInformacion', {
  controller: ViaticosSharedAnticiposAnticipoInformacionComponent,
  template,
  bindings: {
    solicitudId: '<',
    data: '<',
    onSelect: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/anticipos/anticipo/informacion/component.js